import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { MoneyInput } from '../../Currency'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { LISTING_FORM_FIELD_NAME_SERVICE_CHARGE } from '../RentalPortalListing.constants'

function RentalPortalListingServiceChargeField({ isLoading }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={MoneyInput}
      controlProps={{ borderless: !isMobileScreenSize }}
      fieldComponentProps={{
        isLoading,
        label: `${t('RentalPortal.ListingFormServiceChargeLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={LISTING_FORM_FIELD_NAME_SERVICE_CHARGE}
      placeholder={t('RentalPortal.ListingFormServiceChargePlaceholderKey')}
    />
  )
}

export default RentalPortalListingServiceChargeField
